<!-- <common-header [title]="this.title" [items]="items"></common-header> -->

<div class="content">
  <div class="container-fluid">
    <dashboard [isEdit]="true"></dashboard>
  </div>
</div>
